module.exports = __webpack_public_path__ + "images/Group.e46a27f4242f25225839c4bb94f92f60.svg";